import React from 'react'; 

const Preloader = () => (
    <div className="home__preloader">
        <div className="preloader">
            <div className="preloader__spinner" />
            <div className="preloader__spinner" />
            <div className="preloader__spinner" />
            <div className="preloader__spinner" />
            <div className="preloader__spinner" />
        </div>
    </div>
);

export default Preloader;



// WEBPACK FOOTER //
// ./src/components/Preloader.jsx